define('../app/fukit/behavior/confirm.invoke.model.method.on.event.behavior',['require','exports','module','underscore','marionette','./invoke.model.method.on.event.behavior','../view/block/confirm.modal.view'],function(require, exports, module) {
  //prettier-ignore
  var _                                = require('underscore'),
      Mn                               = require('marionette'),
      InvokeModelMethodOnEventBehavior = require('./invoke.model.method.on.event.behavior'),
      ConfirmModalView                 = require('../view/block/confirm.modal.view');

  var ConfirmInvokeModelMethodOnEventBehavior = InvokeModelMethodOnEventBehavior.extend({
    defaults: _.extend({}, InvokeModelMethodOnEventBehavior.prototype.defaults, {
      // the options for the modal
      modalOptions: {},
      // same as modalOptions but kept for legacy support
      confirmModalOptions: {},
      // called when the modal confirm is pressed
      onConfirm: null,
    }),

    onEvent: function() {
      this.eventArgs = _.toArray(arguments);

      //prettier-ignore
      var args                = arguments,
          onConfirm           = this.getOption('onConfirm'),
          confirmModalOptions = Mn._getValue(this.getOption('modalOptions') || this.getOption('confirmModalOptions'), this);

      this.createConfirmModal(_.extend({ visible: true, type: ConfirmModalView }, confirmModalOptions)).on(
        'confirm',
        function() {
          if (onConfirm) {
            onConfirm.call(this, this.getTargetModel());
          }
          this.invokeModelMethod.apply(this, args);
        },
        this
      );
    },

    createConfirmModal: function(options) {
      if (this.view.buildComponent) {
        return this.view.buildComponent(options);
      }
      throw new Error('The ConfirmInvokeModelMethodOnEventBehavior was attached to a non-uikit view');
    },
  });

  module.exports = ConfirmInvokeModelMethodOnEventBehavior;
});

